import { checkValidityBeforeSave, lenientParse, createDateAsUTC } from '../items';

export const getValidRowsWithDates = (rows, dateFields) => {
    let valid = [];

    for (const row of rows) {
        const dateValuesToValidate = dateFields.map((field) => row[field]);

        if (dateValuesToValidate.every((date) => checkValidityBeforeSave(date))) {
            // when all off the provided date fields pass the checks
            // we parse the dates and add the row data to the list of valid rows

            const dates = dateFields.reduce((acc, field) => {
                acc[field] = createDateAsUTC(lenientParse(row[field]));

                return acc;
            }, {});

            valid.push({
                ...row,
                ...dates,
            });
        }
    }

    return valid;
};
